import $ from 'jquery'

import template from './template'
import _ from './constants'
import { adjustCart, toggle } from './actions'

/**
 *
 * Cart conditional check methods
 */

const checkForSpice = (data) => {
  let containsSpice = false

  data.items.forEach((item) => {
    if (item.title === 'Spice 94 - 70 cl' || item.title === 'Spice 94 - 70cl') {
      containsSpice = true
    }
  })

  return containsSpice
}

const checkForSpice20cl = (data) => {
  let containsSpice = false

  data.items.forEach((item) => {
    if (item.title === 'Spice 94 - 20 cl' || item.title === 'Spice 94 - 20cl') {
      containsSpice = true
    }
  })

  return containsSpice
}

const checkForGarden = (data) => {
  let containsGarden = false

  data.items.forEach((item) => {
    if (item.title === 'Garden 108 - 70 cl' || item.title === 'Garden 108 - 70cl') {
      containsGarden = true
    }
  })

  return containsGarden
}

const checkForGrove = (data) => {
  let containsGrove = false

  data.items.forEach((item) => {
    if (item.title === 'Grove 42 - 70 cl' || item.title === 'Grove 42 - 70cl') {
      containsGrove = true
    }
  })

  return containsGrove
}

const checkForGarden20cl = (data) => {
  let containsGarden = false

  data.items.forEach((item) => {
    if (item.title === 'Garden 108 - 20 cl' || item.title === 'Garden 108 - 20cl') {
      containsGarden = true
    }
  })

  return containsGarden
}

const checkForGrove20cl = (data) => {
  let containsGrove = false

  data.items.forEach((item) => {
    if (item.title === 'Grove 42 - 20 cl' || item.title === 'Grove 42 - 20cl') {
      containsGrove = true
    }
  })

  return containsGrove
}

const checkFreeShipping = (data) => {
  if (_.cartShipping && window.store_country === 'United Kingdom' && data.total_weight < 118000) {
    if (data.total_weight < 120000 && data.total_weight >= 80000) {
      _.cartShipping.innerHTML = `Add another bottle for <br /> free shipping in the ${
        window.store_country
      }.`
    } else if (data.total_weight < 80000 && data.total_weight >= 40000) {
      _.cartShipping.innerHTML = `Add another 2 bottles for <br /> free shipping in the ${
        window.store_country
      }.`
    } else if (data.total_weight < 40000) {
      _.cartShipping.innerHTML = ''
    }
  } else if (_.cartShipping && window.store_country === 'United States') {
    if (data.total_price < 5001) {
      _.cartShipping.innerHTML = `Orders over $50 will receive <br /> free shipping in the ${
        window.store_country
      }.`
    } else {
      _.cartShipping.innerHTML = `Your order qualifies for <br /> free shipping in the ${
        window.store_country
      }.`
    }
  } else if (_.cartShipping) {
    _.cartShipping.innerHTML = ''
  }

  return _.cartShipping
}

const checkFor20cl = (data) => {
  const contains20cl = checkForGarden20cl(data) || checkForSpice20cl(data) || checkForGrove20cl(data)
  const numberOfItems = data.item_count

  if (contains20cl && numberOfItems <= 1) {
    _.cartShipping.innerHTML = 'Add another item to be able to proceed to checkout.'
    _.checkoutButton.setAttribute('disabled', true)
  } else {
    _.checkoutButton.removeAttribute('disabled')
  }
}

const checkUpsell = (data) => {
  const containsGarden = checkForGarden(data)
  const containsSpice = checkForSpice(data)
  const containsGrove = checkForGrove(data)


  if ((containsSpice || containsGarden) && !containsGrove) {
    _.upsellGrove.classList.add('is-active')
  } else {
    _.upsellGrove.classList.remove('is-active')
    // _.upsellGarden.classList.remove('is-active')
    // _.upsellSpice.classList.remove('is-active')
  }
}

/**
 *
 * Cart ui update methods
 */

const updateCartItemsHtml = (data) => {
  let html = ''
  data.items.forEach((item, id) => {
    const img1 = item.image.substring(0, item.image.lastIndexOf('.'))
    const img2 = item.image.substring(item.image.lastIndexOf('.'))
    const img = `${img1}_100x${img2}`
    const title = item.product_title
    const price = cartApi.price(item.line_price).split('.')
    const curr = window.location.href.indexOf('seedlipdrinks.com') !== -1 ? '£' : '$'

    html += template(
      item.variant_id,
      title,
      img,
      item.variant_options,
      item.quantity,
      price[0],
      price[1],
      curr,
      id + 1,
    )
  })

  _.cartContent.innerHTML = html
}

const updateCartSwitch = (data) => {
  if (data.item_count >= 1) {
    _.cartSwitch.classList.remove('is-empty')
  } else {
    _.cartSwitch.classList.add('is-empty')
  }

  _.cartSwitch.setAttribute('data-cart', data.item_count)
}

const updateCartPriceHtml = (data) => {
  const totalPrice = cartApi.price(data.total_price).split('.')

  _.priceTotal.innerText = totalPrice[0]
  _.priceTotalUnits.innerText = `.${totalPrice[1]}`
}

const cartApi = {
  adjust: (line, quantity) => {
    $.ajax({
      method: 'post',
      url: '/cart/change.js',
      data: {
        line,
        quantity,
      },
      dataType: 'json',
    }).done(() => {
      cartApi.update()
    })
  },

  add: (formString) => {
    $.ajax({
      method: 'post',
      url: '/cart/add.js',
      data: formString,
      dataType: 'json',
    }).done(() => {
      cartApi.update()
    })
  },

  price: price => (price / 100).toFixed(2),

  clear: () => {
    $.post('/cart/clear.js')
  },

  update: (pushOut = true) => {
    $.getJSON('/cart.js', (data) => {
      // check cart conditionals
      checkFreeShipping(data)
      checkUpsell(data)
      checkFor20cl(data)

      // update cart ui
      updateCartItemsHtml(data)
      updateCartSwitch(data)
      updateCartPriceHtml(data)

      // add quantity button event listeners
      adjustCart()

      // open the cart if specified
      if (pushOut) toggle('open')
    })
  },
}

export default cartApi
